import { Component, OnInit } from '@angular/core';
import { NeproseService } from 'src/app/services/neprose.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-blogs',
  templateUrl: './blogs.component.html',
  styleUrls: ['./blogs.component.css']
})
export class BlogsComponent implements OnInit {

  blogList = []

  constructor( private neproseService: NeproseService) { }

  ngOnInit(): void {
    this.neproseService.getBlogs(0, 'new').subscribe(data => {
      if(data && data.status){
        let blogList = data.blogs
        if(blogList.length > 3){
          blogList.splice(3)
        }
        if(blogList.length > 0){
          for(let blog of blogList){
            blog['featuredImage'] = environment.api + '/images/' + blog['imagePath']
            blog['publishedDate'] = new Date(blog['updatedAt']).toDateString()
            let excerpt = blog.body.replace(/<\/?[^>]+(>|$)/g, '')
            let blogLength = excerpt.length
            let minRead = Math.ceil(blogLength/1000)
            if(minRead > 1){
              blog['minRead'] = minRead +' mins read'
            }else{
              blog['minRead'] = minRead +' minute read' 
            }
            if(excerpt){
              blog['excerpt'] = excerpt.slice(0, 300)
            }else{
              blog['excerpt'] = ''
            }
            this.blogList.push(blog)
          }
        }
      }
    })
  }

}
